// extracted by mini-css-extract-plugin
module.exports = {"inputSearch":"Header_inputSearch__SpefA"};